export const LS_AUTH_TOKEN = "brandhub-silver-user";
